import { render, staticRenderFns } from "./AddSectionControl.vue?vue&type=template&id=8c5ccb0c&"
import script from "./AddSectionControl.vue?vue&type=script&lang=js&"
export * from "./AddSectionControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports